<app-loader *ngIf="loaderIcon | async"></app-loader>
<div class="d-flex justify-content-between align-items-center p-2 shadow-sm" style="background-color: #1A1A31">
  <div class="d-flex align-items-center gap-3">
    <div class="input-group">
      <p class="text-white fw-bold mb-0" style="font-size: 17px;">{{marketName}}</p>
    </div>
  </div>
  <div class="d-flex align-items-center gap-5">
    <button class="btn btn-light d-flex align-items-center gap-2 px-3" style="visibility: hidden">
      <i class="bi bi-calendar"></i>
      <span>25 March 2025</span>
    </button>
    <div class="d-flex align-items-center gap-2">
      <img src="./assets/images/profile.png" class="rounded-circle" style="width: 1.7rem;" />
      <div>
        <div class="text-white medium mb-0">{{userName}}</div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="!processPayment">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 text-strt mt-2">
        <p class="mb-0" style="color: #F46801; font-weight: 600; font-size: 19px;">Payment</p>
      </div>
    </div>
  </div>
  <div class="container-fluid bg-white" [formGroup]="paymentForm">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 col-lg-3 text-strt mt-2">
          <div class="card-custom">
            <div class="text-center mb-3 total-quantity p-3">
              <h6 class="fw-bold mb-1">Total No. of Items : {{quantity}}</h6>
              <p class="text-orange fw-semibold mb-0">Discount : {{discountAmount}}</p>
            </div>
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h6 class="fw-bold mb-0">Customer Info.</h6>
              <div class="d-flex align-items-start mt-2">
                <!-- Search button -->
                <button class="pos-dark-btn me-1" (click)="openCustomerForm('search');openModalById('customerModal')">
                  <img src="./assets/images/search.svg" />
                </button>

                <div class="d-flex flex-column">
                  <button class="btn btnAS btn-sm mb-1" (click)="openCustomerForm('new');openModalById('customerModal')">
                    New
                  </button>
                  <button class="btn btnAS btn-sm mb-1" [disabled]="!existingCustomer"
                          (click)="openCustomerForm('edit');openModalById('customerModal')">
                    Update
                  </button>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between small mb-3">
              <div>
                <div>{{ customerData?.FirstName }} {{ customerData?.LastName }}</div>
                <div>Tel: {{customerData?.Telephone}}</div>
              </div>
              <div class="text-end">
                <div>{{ displayDate }}</div>
                <div>{{ displayTime }}</div>
              </div>
            </div>
            <div class="placeholder-box"></div>
          </div>
        </div>
        <div class="col-md-12 col-lg-6 text-strt">
          <div class="row">
            <div class="col-md-12 col-lg-6 mt-2">
              <div class="card-custom">
                <div class="d-grid gap-2">
                  <div class="card border rounded shadow-sm summary-box p-2">
                    <div class="card-body d-flex justify-content-between align-items-center py-2">
                      <span class="fw-semibold">Item Amount</span>
                      <span class="fw-bold">{{subTotal}}</span>
                    </div>
                  </div>

                  <div class="card border rounded shadow-sm summary-box p-2"
                       *ngIf="!applySalesTaxItemWise">
                    <div class="card-body d-flex justify-content-between align-items-center py-2">
                      <span class="fw-semibold">Sales Tax</span>
                      <span class="fw-bold">{{ paymentForm.get('salesTax')?.value }}</span>
                    </div>
                  </div>

                  <div class="card border rounded shadow-sm summary-box p-2"
                       *ngIf="!applySalesTaxItemWise">
                    <div class="card-body d-flex justify-content-between align-items-center py-2">
                      <span class="fw-semibold">{{secondLevelTaxName}}</span>
                      <span class="fw-bold">{{ paymentForm.get('secondlvlTax')?.value }}</span>
                    </div>
                  </div>

                                    <div class="card border rounded shadow-sm summary-box p-2"
                                        *ngIf="enableOtherChargeinPos">
                                        <div class="card-body d-flex justify-content-between align-items-center py-2">
                                            <span class="fw-semibold mr-1">{{posotherChargeName}}</span>
                                            <input type="text" class="form-control text-end"
                                                (keypress)="numberOnlyWithNegative($event)" placeholder=""
                                                (blur)="formatField('otherCharges')"
                                                (focus)="setActiveControl('otherCharges')"
                                                formControlName="otherCharges" [readonly]="disableOtherCharge()">
                                        </div>
                                    </div>

                  <div class="card border rounded shadow-sm summary-box p-2"
                       *ngIf="saleType == '8' || saleType == '7'">
                    <div class="card-body d-flex justify-content-between align-items-center py-2">
                      <span class="fw-semibold">Credit Card fees</span>
                      <span class="fw-bold">{{ paymentForm.get('ccFeesForVoidAndRet')?.value
                        }}</span>
                    </div>
                  </div>

                                    <div class="card border rounded shadow-sm summary-box p-2"
                                        *ngIf="saleType == '8' || saleType == '7'">
                                        <div class="card-body d-flex justify-content-between align-items-center py-2">
                                            <span class="fw-semibold">Rounded Amount</span>
                                            <span class="fw-bold">{{ paymentForm.get('roundedAmtVoidAndRet')?.value
                                                }}</span>
                                        </div>
                                    </div>

                                    <div class="card border rounded shadow-sm summary-box p-2"
                                        *ngIf="saleType != '8' && saleType != '7'">
                                        <div class="card-body d-flex justify-content-between align-items-center py-2">
                                            <span class="fw-semibold">Credit Card fees</span>
                                            <span class="fw-bold">{{ paymentForm.get('creditCardFees')?.value }}</span>
                                        </div>
                                    </div>                                   

                                    <div class="d-flex flex-wrap mt-2">
                                        <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="checkbox" id="printReceipt" checked
                                                formControlName="printReceipt">
                                            <label class="form-check-label" for="printReceipt">Print Receipt</label>
                                        </div>
                                        <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="checkbox" id="displayReceipt"
                                                formControlName="displayReceipt">
                                            <label class="form-check-label" for="displayReceipt">Display Receipt</label>
                                        </div>                                        
                                        <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="checkbox" id="emailReceipt"
                                                formControlName="emailReceipt">
                                            <label class="form-check-label" for="emailReceipt">Email Receipt</label>
                                        </div>
                                        <div class="email-input-group">
                                            <input type="email" class="form-control" placeholder="Email Address"
                                                formControlName="emailAddress" />

                      <div class="text-danger mt-1"
                           *ngIf="paymentForm.get('emailAddress')?.touched && paymentForm.get('emailAddress')?.invalid">

                        <small *ngIf="paymentForm.get('emailAddress')?.errors?.['required']">
                          Email address is required
                        </small>

                        <small *ngIf="paymentForm.get('emailAddress')?.errors?.['email']">
                          Enter a valid email address
                        </small>

                        <small *ngIf="paymentForm.get('emailAddress')?.errors?.['maxlength']">
                          Email address cannot exceed 75 characters
                        </small>
                      </div>
                    </div>
                  </div>

                  <div class="d-flex flex-wrap mt-2" *ngIf="this.paymentData.SalesType == 'gc'">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="printGCReceipt" checked
                             formControlName="printGC">
                      <label class="form-check-label" for="printGCReceipt">Print GC</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="displayGCReceipt"
                             formControlName="displayGC">
                      <label class="form-check-label" for="displayGCReceipt">Display GC</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12 col-lg-6 mt-2">
              <div class="d-grid gap-2">
                <div class="card border rounded shadow-sm summary-box p-2 mt-2">
                  <div class="card-body d-flex justify-content-between align-items-center py-2">
                    <span class="summary-label">Total Invoice Amount</span>
                    <span class="summary-value">{{paymentForm.get('totalInvoiceAmount')?.value
                      }}</span>
                  </div>
                </div>

                <div class="card border rounded shadow-sm summary-box p-2">
                  <div class="card-body d-flex justify-content-between align-items-center py-2">
                    <span class="summary-label highlight-label">Payment Sub Total</span>
                    <span class="summary-value highlight-value"
                          style="font-size: 19px">{{paymentForm.get('totalPayment')?.value }}</span>
                  </div>
                </div>

                <div class="card border rounded shadow-sm summary-box p-2">
                  <div class="card-body d-flex justify-content-between align-items-center py-2">
                    <span class="summary-label">Balance Due</span>
                    <span class="fw-bold">{{paymentForm.get('balanceDue')?.value }}</span>
                  </div>
                </div>

                <div class="card border rounded shadow-sm summary-box p-2">
                  <div class="card-body d-flex justify-content-between align-items-center py-2">
                    <span class="summary-label">Change Due</span>
                    <span class="summary-value">{{paymentForm.get('changeDue')?.value }}</span>
                  </div>
                </div>

                <div *ngIf="isCashRoundingEnabled"
                     class="card border rounded shadow-sm summary-box p-2">
                  <div class="card-body d-flex justify-content-between align-items-center py-2">
                    <span class="summary-label">Rounding Off Amount</span>
                    <span class="summary-value">
                      {{paymentForm.get('roundingDifference')?.value }}
                    </span>
                  </div>
                </div>

                                <div class="d-flex flex-wrap mt-2">
                                    <div class="form-check form-check-inline" *ngIf="saleType == '7' || saleType == '8'">
                                        <input class="form-check-input" type="checkbox" id="refundAsCash" formControlName="refundAsCash">
                                        <label class="form-check-label" for="refundAsCash">Refund as Cash</label>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 mb-2">
                            <div class="d-none" style="padding: 10px; padding-right: 0px; padding-top: 0px">
                                <div class="row g-1 mb-1">
                                    <div class="col-2">
                                        <button class="amount-btn" (click)="onDenominationClick(5)">$5</button>
                                    </div>
                                    <div class="col-2">
                                        <button class="amount-btn" (click)="onDenominationClick(10)">$10</button>
                                    </div>
                                    <div class="col-2">
                                        <button class="amount-btn" (click)="onDenominationClick(20)">$20</button>
                                    </div>
                                    <div class="col-2">
                                        <button class="amount-btn" (click)="onDenominationClick(50)">$50</button>
                                    </div>
                                </div>
                                <div class="row g-1">
                                    <div class="col-2">
                                        <button class="keypad-btn" (click)="onKeypadClick('1')">1</button>
                                    </div>
                                    <div class="col-2">
                                        <button class="keypad-btn" (click)="onKeypadClick('2')">2</button>
                                    </div>
                                    <div class="col-2">
                                        <button class="keypad-btn" (click)="onKeypadClick('3')">3</button>
                                    </div>
                                    <div class="col-2">
                                        <button class="keypad-btn" (click)="onKeypadClick('4')">4</button>
                                    </div>
                                    <div class="col-2" style="margin-top: 5.5px;">
                                        <button class="amount-btn" (click)="onDenominationClick(100)">$100</button>
                                    </div>
                                </div>
                                <div class="row g-1">
                                    <div class="col-2">
                                        <button class="keypad-btn" (click)="onKeypadClick('5')">5</button>
                                    </div>
                                    <div class="col-2">
                                        <button class="keypad-btn" (click)="onKeypadClick('6')">6</button>
                                    </div>
                                    <div class="col-2" style="margin-bottom: -5px;">
                                        <button class="keypad-btn" (click)="onKeypadClick('7')">7</button>
                                    </div>
                                    <div class="col-2">
                                        <button class="keypad-btn" (click)="onKeypadClick('8')">8</button>
                                    </div>
                                    <div class="col-2" style="margin-top: -3px;">
                                        <button class="amount-btn" (click)="onDenominationClick(500)">$500</button>
                                    </div>
                                </div>
                                <div class="row g-1">
                                    <div class="col-2">
                                        <button class="keypad-btn" (click)="onKeypadClick('9')">9</button>
                                    </div>


                  <div class="col-2">
                    <button class="keypad-btn" (click)="onKeypadClick('.')">.</button>
                  </div>
                  <div class="col-2">
                    <button class="keypad-btn" (click)="onKeypadClick('0')">0</button>
                  </div>
                  <div class="col-2">
                    <button class="keypad-btn" (click)="onClearKey()">
                      <img src="./assets/images/clear.svg" class="img-fluid"
                           style="width: 1.7rem" />
                    </button>
                  </div>
                  <div class="col-2" rowspan="2" style="margin-top: -21px;">
                    <button class="tender-btn"
                            (click)="tenderExactAmount()">TENDER<br>EXACT<br>AMOUNT</button>
                  </div>
                  <div class="col-3 d-none d-lg-block"></div>
                </div>
              </div>
              <div class="keyboard-container" style="display: none;">
                <input class="input-field d-none" [value]="value" readonly />
                <div class="simple-keyboard"></div>
              </div>
            </div>

          </div>

        </div>
        <div class="col-md-12 col-lg-3 text-strt mt-2">
          <h6 class="fw-bold mb-1" style="font-size: 17px">Select Payment Method</h6>
          <div class="payment-box">
            <div class="row">
              <div class="col-6 d-flex">
                <img src="./assets/images/cash.svg" class="payment-icon" alt="Cash">
                <label class="payment-label fw-bold me-2 mt-1">Cash (F2)</label>
              </div>
              <div class="col-6">
                <input type="text" class="form-control payment-input text-end"
                       formControlName="cashAmount"
                       (focus)="activateCashRounding(); setActiveControl('cashAmount')"
                       (blur)="deactivateCashRounding(); formatField('cashAmount')"
                       (keypress)="numberOnlyForCash($event)" appCurrencyInput>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-6 d-flex">
                <img src="./assets/images/check.svg" class="payment-icon" alt="Cheque">
                <label class="payment-label fw-bold me-2 mt-1">Check (F3)</label>
              </div>
              <div class="col-6">
                <input type="text" class="form-control payment-input text-end"
                       formControlName="chequeAmount" (blur)="formatField('chequeAmount')"
                       (focus)="setActiveControl('chequeAmount')" (keypress)="numberOnly($event)"
                       appCurrencyInput>
              </div>
            </div>

            <div class="row mt-2">
              <div class="col-6 d-flex">
                <img src="./assets/images/check.svg" class="payment-icon" alt="Cheque"
                     style="visibility: hidden;">
                <label class="payment-label fw-bold me-2 mt-1">Check #</label>
              </div>
              <div class="col-6">
                <input type="text" class="form-control text-start" #chequeNo
                       (keydown)="onCheckNumKeyPress($event)" placeholder="Check #"
                       formControlName="chequeNo" Maxlength="20">
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-6 d-flex">
                <img src="./assets/images/visa.svg" class="payment-icon" alt="Credit/Debit">
                <label class="payment-label fw-bold me-2 mt-1">Credit/Debit (F4)</label>
              </div>
              <div class="col-6">
                <input type="text" class="form-control payment-input text-end"
                       formControlName="creditCardAmount" (blur)="formatField('creditCardAmount')"
                       (input)="enteredCCAmount()" (focus)="setActiveControl('creditCardAmount')"
                       (keypress)="numberOnly($event)" appCurrencyInput>
              </div>
            </div>

            <div class="row mt-2">
              <div class="col-6 d-flex">
                <img src="./assets/images/visa.svg" class="payment-icon" alt="Credit/Debit"
                     style="visibility: hidden;">
                <label class="payment-label fw-bold me-2 mt-1">Card Type</label>
              </div>
              <div class="col-6">
                <select class="form-control" formControlName="creditCards"
                        (change)="checkPaymentType()">
                  <option *ngFor="let item of creditCardList" [value]="item.CreditCardTypeId">
                    {{item.CreditCardTypeDesc}}
                  </option>
                </select>
              </div>
            </div>

                        <div class="row mt-2">
                            <div class="col-6 d-flex">
                                <img src="./assets/images/traveler-checque.svg" class="payment-icon"
                                    alt="Traveler Cheque">
                                <label class="payment-label fw-bold me-2">{{travelerCheckTerm}} (F5)</label>
                            </div>
                            <div class="col-6">
                                <input type="text" class="form-control payment-input text-end"
                                    formControlName="travelerCheckAmt" (blur)="formatField('travelerCheckAmt')"
                                    (focus)="setActiveControl('travelerCheckAmt')" (keypress)="numberOnly($event)"
                                    appCurrencyInput>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-6 d-flex">
                                <img src="./assets/images/traveler-checque.svg" class="payment-icon"
                                    alt="Traveler Cheque" style="visibility: hidden;">
                                <label class="payment-label fw-bold me-2">{{travelerCheckTerm}} #</label>
                            </div>
                            <div class="col-6">
                                <input type="text" class="form-control payment-input text-end" #traverlerCheckNo
                                    (keydown)="onCheckNumKeyPress($event)" placeholder="{{travelerCheckTerm}} Check #"
                                    formControlName="traverlerCheckNo">
                            </div>
                        </div>

                        <div class="row mt-2" *ngIf="saleType != 'gc' && saleType != '7'">
                            <div class="col-6 d-flex">
                                <img src="./assets/images/gift-voucher.svg" class="payment-icon" alt="Gift Certificate">
                                <label class="payment-label fw-bold me-2 mt-1">Gift Certificate #</label>
                            </div>
                            <div class="col-6">
                                <div class="search-box">
                                    <input type="text" class="form-control" formControlName="appliedGCNo"
                                        (blur)="validateEnteredGCNo()">
                                    <button type="button" (click)="openModalById('modalGiftCertificate')">
                                        <img src="./assets/images/search.svg" class="img-fluid" />
                                    </button>
                                </div>
                            </div>
                            <div class="col-6">
                                <img src="./assets/images/gift-voucher.svg" class="payment-icon" alt="Gift Certificate"
                                    style="visibility: hidden;">
                                <label class="payment-label fw-bold me-2 mt-1">GC Amount</label>
                            </div>
                            <div class="col-6 mt-2">
                                <input type="text" class="form-control payment-input text-end"
                                    formControlName="appliedGCAmount" (blur)="formatField('appliedGCAmount')">
                            </div>
                            <ng-container *ngIf="selectedGCExpiryDate">
                                <div class="col-6">
                                    <img src="./assets/images/gift-voucher.svg" class="payment-icon" alt="Gift Certificate"
                                        style="visibility: hidden;">
                                    <label class="payment-label fw-bold me-2 mt-1">GC Expiry Date</label>
                                </div>
                                <div class="col-6 mt-2">
                                    <input type="text" class="form-control payment-input text-end" [value]="selectedGCExpiryDate" readonly>
                                </div>
                            </ng-container>
                        </div>
                    </div>

          <div class="row">
            <div class="col-md-12" style="text-align: right;">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" id="keyedInTrans"
                       formControlName="keyedInTransaction">
                <label class="form-check-label" for="keyedInTrans">Keyed In Transaction</label>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <button class="btn btn-success w-100 mt-2" (click)="saveSalesPayment()"
                      *ngIf="saleType != 8">Proceed to
                Payments</button>
              <button class="btn btn-orange w-100 mt-2" (click)="saveSalesPayment()"
                      *ngIf="saleType == 8">Complete Void</button>
              <button class="btn btn-outline-orange w-100 my-1" (click)="cancelPaymentPage()">Back</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="processPayment && IsOpenEdgeExpress && !voidPayment">
  <app-payment [VendorId]="vendorId" [keyedInTransaction]="this.paymentForm.get('keyedInTransaction').value"
               [CCAmount]="creditCardAmount" [TransactionType]="transactionType" [voidPayment]="voidPayment"
               (PaymentResponse)="paymentResponse($event)" [VerifoneId]="verifoneId"
               (ClosePaymentPage)="ClosePaymentPage($event)" [PosRequest]="PosRequest"></app-payment>
</div>

<div *ngIf="processPayment && IsStrip">
  <app-stripe-payment [VendorId]="vendorId" [customerData]="customerData" [keyedInTransaction]="this.paymentForm.get('keyedInTransaction').value"
                      [CCAmount]="creditCardAmount" [TransactionType]="transactionType" [voidPayment]="voidPayment"
                      (PaymentResponse)="paymentResponse($event)" [PosRequest]="PosRequest"
                      (ClosePaymentPage)="ClosePaymentPage($event)"></app-stripe-payment>
</div>

<div *ngIf="voidPayment && IsStrip">
  <app-stripe-payment [VendorId]="vendorId" [voidPayment]="voidPayment" (PaymentResponse)="voidPaymentResponse($event)"
                      [VerifoneId]="verifoneId" [PosRequest]="PosRequest" [ForceCreditReturn]="forceCreditReturn" [RefundAmount]="refundAmount"></app-stripe-payment>
</div>

<div *ngIf="voidPayment && IsOpenEdgeExpress">
  <app-payment [VendorId]="vendorId" [voidPayment]="voidPayment" (PaymentResponse)="voidPaymentResponse($event)"
               [VerifoneId]="verifoneId" [PosRequest]="PosRequest" [ForceCreditReturn]="forceCreditReturn" [RefundAmount]="refundAmount"></app-payment>
</div>

<div class="modal fade" id="customerModal" #customerModal tabindex="-1" aria-labelledby="customerModalLabel"
     aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title" id="customerModalLabel" *ngIf="customerSearch">Customer Search</h5>
        <h5 class="modal-title" id="customerModalLabel" *ngIf="!customerSearch">Customer Information</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body">
        <div class="row">
          <div class="col-12">
            <div>
              <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left mt-3">
                <app-pos-customer-search [customerSearch]="customerSearch" [newForm]="newCustomer"
                                         [customerId]="customerId" (customerData)="CustomerInfo($event)"
                                         (closeCustomerInfoModal)="closeCustomerInfoModal($event)">
                </app-pos-customer-search>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer" *ngIf="customerSearch">
        <button type="button" class="btn btn-orange me-1"  (click)="closeModalById('customerModal')">Close</button>
      </div>
    </div>
  </div>
</div>
<!-- Modal -->
<div class="modal fade" id="modalGiftCertificate" #modalGiftCertificate tabindex="-1"
    aria-labelledby="modalGiftCertificateLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="modalGiftCertificateLabel">Gift Certificate Search</h1>
                <button type="button" class="btn-close" (click)="closeModalById('modalGiftCertificate')"></button>
            </div>
            <div class="modal-body">
                <div class="row g-2 align-items-end">
                    <div class="col-md-6 col-lg-4 text-start">
                        <label for="searchField" class="form-label">Search Field</label>
                        <select id="searchField" class="form-select" [(ngModel)]="gcSearchField" (change)="filterGiftCertificates()">
                            <option value="GiftCertificateNo">Gift Certificate #</option>
                            <!-- <option value="ItemDescription">Item Description</option> -->
                            <option value="CustomerName">Customer</option>
                            <option value="StartDate">Start Date</option>
                            <option value="ExpiryDate">Expire Date</option>
                        </select>
                    </div>
                    <div class="col-md-6 col-lg-4 text-start">
                        <label for="searchValue" class="form-label">Search Value</label>
                        <input type="text" id="searchValue" class="form-control" [(ngModel)]="gcSearchValue" (input)="filterGiftCertificates()">
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-start mt-2">
                        <ejs-grid [height]="250" [dataSource]="filteredGiftCertificateList"
                            (rowSelected)='giftCertificateSelected($event)'>
                            <e-columns>
                                <e-column field="GiftCertificateNo" headerText="Gift Certificate #" textAlign="Left"
                                    width="150"></e-column>
                                <e-column field="ItemDescription" headerText="Item Description" textAlign="Left"
                                    width="200"></e-column>
                                <e-column field="StartDate" headerText="Start Date" textAlign="Left"
                                    width="150"></e-column>
                                <e-column field="ExpiryDate" headerText="Expire Date" textAlign="Left"
                                    width="150"></e-column>
                                <e-column field="Balance" headerText="Balance" textAlign="Right" width="100"></e-column>
                                <e-column field="CustomerName" headerText="Customer" textAlign="Left"
                                    width="200"></e-column>
                            </e-columns>
                        </ejs-grid>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btnAS me-1">Save</button>
                <button type="button" class="btn btn-orange" (click)="closeModalById('modalGiftCertificate')">Cancel</button>

      </div>
    </div>
  </div>
</div>

<!-- Receipt Modal -->
<div class="modal fade" id="printReceiptPopup" #printReceiptPopup tabindex="-1" aria-labelledby="printReceiptModalLabel"
     aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl modal-fullSize">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="printReceiptModalLabel">Preview</h5>
        <button type="button" class="btn-close" (click)="closeModalById('printReceiptPopup')"></button>
      </div>

      <div class="modal-body">
        <!-- Loading Spinner -->
        <div class="text-center py-5" *ngIf="loading; else pdfViewReceipt">
          <div class="spinner-border text-primary" role="status"></div>
          <p class="mt-2 text-muted">Loading receipt...</p>
        </div>

        <!-- PDF View -->
        <ng-template #pdfViewReceipt>
          <iframe *ngIf="receiptUrl" [src]="receiptUrl" width="100%" height="500px" frameborder="0"></iframe>
        </ng-template>
      </div>
      <div class="modal-footer">
        <button class="btn btn-orange" (click)="closeModalById('printReceiptPopup')">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- Receipt Modal -->
<div class="modal fade" id="printGCPopup" #printGCPopup tabindex="-1" aria-labelledby="printGCPopupLabel"
     aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl modal-fullSize">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="printGCPopupLabel">Preview</h5>
        <button type="button" class="btn-close" (click)="closeModalById('printGCPopup')"></button>
      </div>

      <div class="modal-body">
        <!-- Loading Spinner -->
        <div class="text-center py-5" *ngIf="loading; else pdfViewGCReceipt">
          <div class="spinner-border text-primary" role="status"></div>
          <p class="mt-2 text-muted">Loading receipt...</p>
        </div>

        <!-- PDF View -->
        <ng-template #pdfViewGCReceipt>
          <iframe *ngIf="gcreceiptUrl" [src]="gcreceiptUrl" width="100%" height="500px" frameborder="0"></iframe>
        </ng-template>
      </div>
      <div class="modal-footer">
        <button class="btn btn-orange" (click)="closeModalById('printGCPopup')">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="voidOnlineCCConfirmModal" #voidOnlineCCConfirmModal aria-hidden="true"
     aria-labelledby="voidOnlineCCConfirmModalLabel" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="voidOnlineCCConfirmModalLabel">Void Credit Card Payment</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>

      <div class="modal-body">
        <div class="row">

          <div class="col-md-6">
            <label>Total Amount Paid</label>
            <input type="text" [value]="ccAmountPaid | customCurrency" class="form-control" readonly>
          </div>

          <div class="col-md-6">
            <label>Invoice #</label>
            <input type="text" [value]="this.paymentData?.MarketInvoiceNo" class="form-control" readonly>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-orange" data-bs-dismiss="modal">Cancel</button>
        <button class="btn btnAS me-1" (click)="saveVoidSales()">Void</button>
      </div>
    </div>
  </div>
</div>
